module.exports = __webpack_public_path__ + "static/media/Email.5991d8f5.svg";